import { render, staticRenderFns } from "./ViewDistrict.vue?vue&type=template&id=0a2bc12a&scoped=true"
import script from "./ViewDistrict.vue?vue&type=script&lang=js"
export * from "./ViewDistrict.vue?vue&type=script&lang=js"
import style0 from "./ViewDistrict.vue?vue&type=style&index=0&id=0a2bc12a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2bc12a",
  null
  
)

export default component.exports